module.exports = __webpack_public_path__ + "static/img/01.a297ab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/01.png
// module id = ltTG
// module chunks = 1